import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch, useLocation } from 'react-router-dom';

import { ADD_JOURNAL_PAGE, SAVE_JOURNAL_PAGE, TOGGLE_JOURNAL_MORE, GET_JOURNAL_SUCCESS } from '../../redux/actions';
import axios from "axios";
import { serverUrl } from '../../components/Helpers/Config'

import Sidebar from '../../components/Sidebar/Sidebar';
import ButtonBlue from '../../components/Button/ButtonBlue';
import JournalCard from '../Journal/JournalCard';

import '../../styles/journal.styles.scss';

import { BsThreeDotsVertical } from 'react-icons/bs';
import * as AiIcons from 'react-icons/ai';

import { getVideosGallery } from '../../redux/actions/videogallery';
import SearchBar from '../../components/Searchbar';
import { staticFiles } from '../../components/Helpers/Static';
import Swal from 'sweetalert2';
import { BgBlue, Card } from '../Theme';
import { fillList, hideShareto, showShareto } from '../../redux/actions/sharePost';
import ShareTo from './ShareTo';
import { tokenAuthorize } from '../../components/Helpers/Common';
import { VideoTrack } from "../../components/VideoTrack";
import Loading from "../../components/Button/Loading";
import Loader, { CommunityLoader } from "../../components/Button/Loader";
const VIDEOGALLERYSIDEBARDATA = [
    {
        title: 'Topics',
        iconClosed: <AiIcons.AiFillCaretRight />,
        iconOpened: <AiIcons.AiFillCaretDown />,
        item: [],
        open: true,
    }
]

function VideoGallery(props) {

    const { path } = useRouteMatch();

    const dispatch = useDispatch();
    const videosList = useSelector(state => state.videoGallery?.videosList);
    const loading = useSelector(state => state.videoGallery?.isLoading);
    const totalPosts = useSelector(state => state.journal.totalPosts)
    const [postSelection, setPostSelection] = useState([]);
    const [video, setvideo] = useState(videosList);
    const history = useHistory()
    const [filterOptions, setFilterOptions] = useState(VIDEOGALLERYSIDEBARDATA)
    const [searchField, setSearchField] = useState('')
    //nithish added

    const defaultVideoName = Object.keys(videosList)[0];
    const [selectedOption, setSelectedOption] = useState(
        ""
    );

    useEffect(() => {
        setSelectedOption(defaultVideoName);
    }, [defaultVideoName])

    useEffect(() => {
        dispatch(getVideosGallery())
    },
        [dispatch])

    useEffect(() => {
        const videoGroupName = selectedOption;
        const videosList1 = Object.keys(videosList)
            .filter(key => key === videoGroupName)
            .reduce((obj, key) => {
                obj[key] = videosList[key];
                return obj;
            }, {});

        setvideo(videosList1);
    },
        [selectedOption])
    // ----------------------------------------------------------------------------------------------------------------------------
    const [filteredPost, setFilteredPost] = useState([])
    const [dropdown, setDropdown] = useState(false)

    const LOADING_GIF = staticFiles.loading;

    const setFilterValue = (value) => {
        setSelectedOption(value)
    }

    const createNewPost = () => {
        history.push(`${path}/new`);
    }

    return (
        <>
            {
                props.loading || loading ?
                    <CommunityLoader /> :
                    <div className="flex flex-col md:flex-col lg:flex-row pt-0 mb-8">
                        <div className="flex flex-row-reverse lg:flex-col border-right-f1">
                            <div className='w-full border-bottom-f1 p-3.5 box-border'>
                                <SearchBar setSearchField={setSearchField} />
                            </div>
                            <Sidebar
                                data={filterOptions}
                                selectedOption={selectedOption}
                                setSelectedOption={setFilterValue}
                                videosList={videosList}//nithish added
                                isVideoGroup={true}
                            />
                        </div>
                        <div className='w-full backGroundColor pb-5'>
                            {/* <div className="block md:hidden mx-5">
                    <ButtonBlue onClick={createNewPost} title={'+ ADD POST'} width="full" />
                </div> */}
                            <div>
                                {Object.entries(video)?.map((key, index) => {

                                    return (
                                        key?.map((keys, ind) => {
                                            if (typeof keys === 'string') {
                                                return (
                                                    <div className="flex cardBackgroundColor p-5 mb-4 px-5 items-center">
                                                        <div className='col-12 text-lg blackColor font-bold'>
                                                            {keys}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            if (Array.isArray(keys)) {
                                                return (
                                                    <div className='grid grid-cols-1 md:grid-cols-3 xl:grid-cols-3 gap-4 px-5'>
                                                        {keys?.map((i, idx) => {
                                                            return (
                                                                <VideoTrack data={i} />
                                                            )
                                                        })}
                                                    </div>
                                                )
                                            }
                                        })
                                    )
                                })}
                            </div>
                        </div>
                    </div>
            }</>
    )
}

export default VideoGallery;